import { downgradeComponent } from '@angular/upgrade/static';
import { HistoryMailForTransferComponent } from '@commons/history/history-mail/history-mail-for-transfer.component';
import { HistoryMailComponent } from '@commons/history/history-mail/history-mail.component';
import { module } from 'angular';

import { default as historyMailServiceName, HistoryMailService } from './hitsory-mail.service';
import { default as mailCommentName, MailComment } from './mail-comment/mail-comment.component';
import { default as mailEventPopinName, MailEventPopin } from './mail-event-popin/mail-event-popin.component';
import { default as mailEventName, MailEvent } from './mail-event/mail-event.component';

export default module('contact.commons.history.mail', [])
  // DOWNGRADED COMPONENT
  .directive(
    'historyMail',
    downgradeComponent({ component: HistoryMailComponent, inputs: ['epticaEvents', 'memo'] }) as angular.IDirectiveFactory
  )
  .directive(
    'historyMailForTransfer',
    downgradeComponent({ component: HistoryMailForTransferComponent, inputs: ['epticaEvents', 'memo', 'responseId'] })
  )
  .service(historyMailServiceName, HistoryMailService)
  .component(mailCommentName, new MailComment())
  .component(mailEventName, new MailEvent())
  .component(mailEventPopinName, new MailEventPopin()).name;
